import { Link } from "react-router-dom";
import { blogPosts } from "../../../mocks/blog";

const categoryColors: Record<string, string> = {
  "Product Sourcing": "bg-amber-50 text-amber-700",
  Wholesale: "bg-[#D9E2EC] text-[#3A506B]",
  Inventory: "bg-teal-50 text-teal-700",
  Logistics: "bg-slate-100 text-slate-600",
  "Supply Chain": "bg-[#C9A227]/10 text-[#C9A227]",
};

export default function TrendingStrip() {
  const recent = blogPosts.slice(0, 5);

  return (
    <section className="py-12 bg-white border-t border-[#F0F2F5]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <div className="w-1.5 h-6 rounded-full bg-[#C9A227]"></div>
            <h2 className="text-lg font-extrabold text-[#222831]">Latest Articles</h2>
          </div>
          <span className="text-xs text-[#3A506B]/50 flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            Updated weekly
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {recent.map((post, idx) => {
            const catStyle = categoryColors[post.category] ?? "bg-gray-100 text-gray-600";
            return (
              <Link
                key={post.id}
                to={`/blog/${post.slug}`}
                className="group flex flex-col gap-3 cursor-pointer"
              >
                <div className="relative w-full h-36 rounded-xl overflow-hidden">
                  <img
                    src={post.coverImage}
                    alt={post.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <span className="absolute top-2 left-2 text-xs font-extrabold text-[#222831]/60 bg-white/80 rounded-full px-2 py-0.5">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                </div>
                <div>
                  <span className={`inline-block text-xs font-bold uppercase tracking-wide px-2 py-0.5 rounded-full mb-1.5 ${catStyle}`}>
                    {post.category}
                  </span>
                  <h3 className="text-sm font-bold text-[#222831] leading-snug group-hover:text-[#C9A227] transition-colors line-clamp-2">
                    {post.title}
                  </h3>
                  <p className="text-xs text-[#3A506B]/60 mt-1 flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {post.readTime} min &middot; {post.date.split(" ").slice(0, 2).join(" ")}
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
